import { newSize, newTextPinComponent, newVector, fallbackCopy, newAnswerAreaPinComponent } from '../helpers';
import { PollPinLayoutTemplate } from '../models';
import { stringToProsemirror } from '../tip-tap';

export const pollTitleOnlyLayout = ({
  question = fallbackCopy['poll.title'],
  backgroundColor,
  backgroundImage,
}: {
  question?: string;
  backgroundColor?: string;
  backgroundImage?: string;
}): PollPinLayoutTemplate => {
  return {
    key: 'TITLE_ONLY',
    backgroundColor,
    backgroundImage,
    layoutParts: {
      TITLE: newTextPinComponent({
        position: newVector(32, 32),
        size: newSize(896, 60),
        content: stringToProsemirror(question, {
          bold: true,
        }),
        order: 'a0',
        settings: {
          typographyKey: 'headline',
          horizontalAlignment: 'center',
        },
      }),
      ANSWER_AREA: newAnswerAreaPinComponent({
        order: 'a1',
      }),
    },
    pinComponents: [],
  };
};
